import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { quizInputTypesArray } from '../../_models/staticArray'
import { QuizService } from 'src/app/services/quiz.service';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { FileTileComponent } from 'src/app/commons/file-tile/file-tile.component';
import * as _ from 'lodash'

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
@Component({
  selector: 'app-create-quiz',
  templateUrl: './create-quiz.component.html',
  styleUrls: ['./create-quiz.component.scss']
})
export class CreateQuizComponent implements OnInit {
  public Editor = ClassicEditor;
  loading: boolean = false;
  buttonLoaderDelete: boolean = false;
  types = quizInputTypesArray
  //  ['Text', 'Dropdown', 'Dragable Cards', 'Radio', 'None']
  questionsForm: any;
  selectedIndex = 0;
  showOptions: boolean;
  quizId: any;
  quizEdit: any;
  quizName: any;
  quizDescription: any;
  isDate: any;

  isUnits: any;
  isEvidence: any;
  detailsForm: FormGroup;
  isSummaryTitle
  isSummaryData
  isAdditionalData
  jobId: string;
  checkAnswers: any;
  minMarks: any;
  inputList: any;
  deletedImages = [];
  correctAnswer: any;
  files = []
  calcScore: any;
  constructor(
    public _change: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public _quizService: QuizService,
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    public _location: Location
  ) {
    this.createForm()



  }

  ngOnInit() {
    this.loading = true;

    this.activatedRoute.queryParams.subscribe(qparam => {
      this.quizId = qparam.quizId
      console.log("QPARAM IN CREATE QUIZ", qparam)
      this.jobId = qparam.jobId
      console.log(window.history.state);
      // this.quizId = '5f2e794f1b2fb62ed17b130e'
      this.getQuestions()
      // this.getQuiz()
    });
    console.log(window.history.state);

  }

  createForm(details?) {
    console.log("when from edit", details);

    this.questionsForm = new FormGroup({
      quizName: new FormControl(this.quizName ? this.quizName : '', Validators.required),
      quizDescription: new FormControl(this.quizDescription ? this.quizDescription : ''),
      checkAnswers: new FormControl(this.checkAnswers ? this.checkAnswers : false),
      minMarks: new FormControl(this.minMarks ? this.minMarks : ''),
      date: new FormControl(this.isDate ? this.isDate : false),
      units: new FormControl(this.isUnits ? this.isUnits : false),
      evidence: new FormControl(this.isEvidence ? this.isEvidence : false),
      question: this.formBuilder.array(this.questionArray(details ? details.questions : undefined)),
      calcScore: new FormControl(this.calcScore ? this.calcScore : false),
    });


    this.detailsForm = new FormGroup({
      summaryTitle: new FormControl(this.isSummaryTitle ? this.isSummaryTitle : ''),
      summaryData: new FormControl(this.isSummaryData ? this.isSummaryData : ''),
      additionalData: new FormControl(this.isAdditionalData ? this.isAdditionalData : ''),
      criteria: this.formBuilder.array(this.criteriaArray((details && details.quizDetail && details.quizDetail.quizCriteria) ? details.quizDetail.quizCriteria : ''))
    });
    if (this.questionsForm.question) {

    }
    this.loading = false;
  }

  criteriaArray(details?) {
    console.log("details =========++>", details)
    if (details && details.length) {
      let criteriaArray = [];
      details.forEach((singleCriteria) => {
        criteriaArray.push(this.formBuilder.group({
          title: new FormControl(singleCriteria.title),
          heading1: new FormControl(singleCriteria.heading1),
          heading2: new FormControl(singleCriteria.heading2),
          subheading: new FormControl(singleCriteria.subheading),
          showReference: new FormControl(singleCriteria.showReference),
          list: this.formBuilder.array(this.criteriaListArray(singleCriteria.list ? singleCriteria.list : ''))
        }))
      });
      return criteriaArray;
    }
    //else {
    //  return []
    //}
    else {
      return [this.formBuilder.group({
        title: new FormControl(''),
        heading1: new FormControl(''),
        heading2: new FormControl(''),
        subheading: new FormControl(''),
        showReference: new FormControl(false),
        list: this.formBuilder.array(this.criteriaListArray())
      })]
    }
  }

  criteriaListArray(list?) {
    console.log("List =======> ,", list)
    if (list) {
      let listArray = []
      list.forEach((singleList) => {
        let form: any;
        if (singleList.singleCriteria == '') {
          form = this.formBuilder.group({
            singleCriteria: new FormControl('')
          });
        }
        else {
          form = this.formBuilder.group({
            singleCriteria: new FormControl(singleList.singleCriteria)
          });
        }
        listArray.push(form)
      })
      return listArray
    }
    else {
      return [this.formBuilder.group({
        // singleCriteria: ['', Validators.required]
        singleCriteria: new FormControl('', Validators.required)
      })]

    }
  }

  get questionsFormData() { return <FormArray>this.questionsForm.get('question'); }
  get detailsFormData() { return <FormArray>this.detailsForm.get('criteria'); }
  // get optionsData() { return <FormArray>this.questionsForm.controls['question'].get('options'); }

  questionArray(details?) {
    console.log("in quiestion =-> ", details, details);
    if (details && details.length) {
      let temp = [];

      for (let i = 0; i < details.length; i++) {
        temp.push(this.formBuilder.group({
          //inputList: new FormControl(String(details[i].inputMo)),
          totalInputs: new FormControl(details[i].inputNo ? details[i].inputNo : 1),
          inputList: this.formBuilder.array(this.inputArray(details && details[i].inputList ? details[i].inputList : [{ input: 1, placeholder: 'Answer' }])),
          title: new FormControl(details[i].question.title),
          description: new FormControl(details[i].question.description),
          type: new FormControl(details[i].questionType),
          correctAnswer: new FormControl(details[i].correctAnswer),
          isRequired: new FormControl(details[i].isRequired),
          options: this.formBuilder.array(this.optionsArray(details[i].options)),
          questionId: new FormControl(details[i]._id),
          files: this.formBuilder.array(this.filesArray(details[i].files)),
          weightage: new FormControl(details[i].weightage ? details[i].weightage : 1)
        }))
      }
      console.log("whole question", temp)
      return temp
    }
    else {
      return [this.formBuilder.group({
        title: ['', Validators.required],
        description: [''],
        type: ['', Validators.required],
        correctAnswer: [''],
        isRequired: new FormControl(false),
        totalInputs: new FormControl(1),
        inputList: this.formBuilder.array(this.inputArray([{ input: 1, placeholder: 'Answer' }])),
        options: this.formBuilder.array(this.optionsArray()),
        files: new FormArray([]),
        weightage: new FormControl(1)
      })]
    }
  }

  inputArray(details?) {
    if (details && details.length) {
      let inputs = []
      _.forEach(details, async (input, index) => {
        await inputs.push(new FormGroup({
          input: new FormControl((input && input.input) ? input.input : 1),
          placeholder: new FormControl((input && input.placeholder) ? input.placeholder : 'Answer'),
        }))
      })
      console.log('unitssssssssssssss', inputs)
      return inputs;
    } else {
      let inputs = []
      //for (let i = 0; i < this.totalInputs; i++) {
      inputs.push(new FormGroup({
        input: new FormControl(1),
        placeholder: new FormControl('Answer'),
      }))
      //}
      return inputs;
    }
  }
  filesArray(details?) {
    let temp = [];
    if (details) {
      for (let i = 0; i < details.length; i++) {
        temp.push(details[i]);
        // temp.push(this.formBuilder.group({
        //   singleOption: new FormControl(details[i])
        // }))
      }
      return temp

    }
    else {
      return temp;
    }
    console.log("files", details)
    // return temp
  }
  optionsArray(details?) {
    if (details) {
      let temp: any = [];
      for (let i = 0; i < details.length; i++) {
        let form: any;
        if (details[i] == '') {
          form = this.formBuilder.group({
            singleOption: new FormControl('')

          })
          form.clearValidators();
          form.updateValueAndValidity();
        }
        else {
          form = this.formBuilder.group({
            singleOption: new FormControl(details[i])
          })
        }
        console.log("form options ==============+> ", form)
        temp.push(form)
      }
      console.log("option array on init =====?", temp)
      return temp
    }
    else {
      return [this.formBuilder.group({
        singleOption: new FormControl('', Validators.required)
      })]
    }
  }

  addNewQuestion() {
    const control = <FormArray>this.questionsForm.controls.question;
    control.push(
      this.formBuilder.group({
        title: ['', Validators.required],
        description: [''],
        inputList: this.formBuilder.array(this.inputArray([{ input: 1, placeholder: 'Answer' }])),
        totalInputs: new FormControl(1),
        type: new FormControl(''),
        correctAnswer: new FormControl(''),
        isRequired: new FormControl(false),
        options: this.formBuilder.array(this.optionsArray()),
        files: new FormArray([]),
        weightage: new FormControl(1)
      })
    )

    console.log("FORM", this.questionsForm)
  }


  removeQuestion(i, el) {
    console.log('element', el, i)
    this.openDialog(DeleteConfirmModalComponent, 'Delete').subscribe(confirm => {
      if (!confirm) return
      else {
        console.log("confirm =======>", confirm);
        if (confirm == 'yes') {
          if (el.value.questionId) {
            // this.loading = true
            this._quizService.deleteQuestion(this.quizId, el.value.questionId).subscribe(res => {
              console.log("res after delete", res);
              this.openSnackBar("Question deleted successfully", "OK")
              const control = <FormArray>this.questionsForm.controls.question;
              <FormArray>this.questionsForm.get('question').controls.splice(i, 1);
              <FormArray>this.questionsForm.get('question').value.splice(i, 1);
              this.questionsForm.get('question').updateValueAndValidity();
              this._change.detectChanges();
              this.getQuestions();
              // this.loading = false
              // control.removeAt(i)
            })
          }
          else {
            const control = <FormArray>this.questionsForm.controls.question;
            control.removeAt(i)
          }
        }
      }
    })
  }

  addNewOption(quesEl) {
    console.log("this is for option add", quesEl);

    console.log("FORM", this.questionsForm)
    const control = <FormArray>quesEl.controls.options;
    control.push(
      this.formBuilder.group({
        singleOption: ['', Validators.required]
      })
    )
    console.log("AFTER GET THE FORM DATA", this.questionsForm)
  }

  removeOption(el, optionIndex) {
    const control = <FormArray>el.controls.options;
    console.log("controlll => ", control);
    control.removeAt(optionIndex)
  }

  addNewCriteria() {
    const control = <FormArray>this.detailsForm.controls.criteria;
    control.push(
      this.formBuilder.group({
        title: [''],
        heading1: [''],
        heading2: new FormControl(''),
        subheading: [''],
        showReference: new FormControl(false),
        list: this.formBuilder.array(this.criteriaListArray())
      })
    )

    console.log("FORM", control)
  }

  addNewListItem(item, index) {
    console.log("Itms in add list ====+> ", item, index)
    console.log("FORM", this.detailsForm)
    const control = <FormArray>item.controls.list;
    let listForm: FormGroup = this.formBuilder.group({
      singleCriteria: ['', Validators.required]
    })
    control.push(listForm
    )
  }

  deleteListItem(item, index) {
    console.log("Itms in add list ====+> ", item, index)
    const control = <FormArray>item.controls.list;
    control.controls.splice(index, 1)
    control.value.splice(index, 1)
    console.log("control ", control)
  }

  deleteCriteria(item, detailsIndex) {
    console.log("detailsIndex => ", detailsIndex);
    console.log("item => ", item, " ======+> ", this.detailsFormData.controls);
    console.log("item => ======+> ", this.detailsFormData);
    // this.detailsFormData.controls.removeAt(detailsIndex)
    this.detailsFormData.controls.splice(detailsIndex, 1);
    this.detailsFormData.value.splice(detailsIndex, 1);
    this.detailsForm.updateValueAndValidity();
  }

  deleteQuiz(quizId) {
    this.openDialog(DeleteConfirmModalComponent, 'quiz').subscribe(confirm => {
      if (!confirm) return
      if (confirm == 'yes') {
        this.buttonLoaderDelete = true;
        this.openSnackBar("Quiz being deleting", "OK")
        this._quizService.deleteQuiz(this.quizId).subscribe(res => {
          this.openSnackBar("Quiz Deleted", "OK")
          this.buttonLoaderDelete = false
          console.log("res in component")
          this.router.navigateByUrl('jobs/' + this.jobId)
        })
      }
    })

  }
  totalInputChanged(event, el, i) {
    console.log("eventeventevent", el)
    console.log('i')
    const control = <FormArray>el.controls.totalInputs;
    console.log("control", control)
    //let inputs = [] 
    const inputControl = <FormArray>el.controls.inputList;

    console.log("inputControl", inputControl)
    if (inputControl && inputControl.length) {
      inputControl.clear()
    }
    for (let i = 0; i < control.value; i++) {
      inputControl.push(new FormGroup({
        input: new FormControl(i + 1),
        placeholder: new FormControl('Answer'),
      }))
    }
    console.log("<FormArray>el.controls", <FormArray>el.controls)

    //inputControl.push(inputs)
    //return inputs;
  }

  cardClick(i) {
    this.selectedIndex = i
  }

  trackByIndex(index, item) {
    return index;
  }

  typeChanged(event, i, el) {
    if (event.value == 'Text' || event.value == 'None') {
      <FormArray>el.controls.options.controls.forEach((singleControl) => {
        console.log("Single comtrol ======>", singleControl)
        singleControl.controls.singleOption.clearValidators()
        singleControl.controls.singleOption.updateValueAndValidity();
      });
      // control.clearValidators();
      // control.updateValueAndValidity();
      $('#' + i).hide()
      // console.log("control", control.controls[i])
      // control.controls[i].get('correctAns').enable()
      // this.questionsForm.controls['correctAnswer'].disable();
      // this.showOptions = false
    }
    else {
      <FormArray>el.controls.options.controls.forEach((singleControl) => {
        console.log("Single comtrol ======>", singleControl)
        singleControl.controls.singleOption.setValidators([Validators.required])
        singleControl.controls.singleOption.setValidators([Validators.required]);
      });
      console.log("ALL QUESTION FORMS LIST", this.questionsForm.value)
      $('#' + i).show()
      // this.questionsForm.controls.question.controls[i].controls['options'] = {singleOption: ''}
      // console.log("control", control.controls[i])
      // control.controls[i].get('correctAns').disable()
      // this.showOptions = true
    }
  }

  correctAnsChanged(el, optionEl, optionIndex, questionIndex) {
    console.log("correctAnsChanged")
    console.log("%c Question ====> ", "color=red", el)
    console.log("%c option ====> ", "color=blue", optionEl)
    console.log("%c optionIndex ====> ", "color=purple", optionIndex)
    const control = <FormArray>this.questionsForm.controls.question;
    console.log("%cCONTROLS", "color:red", control)
    // console.log(control.controls[i])
    control.controls[questionIndex].patchValue({
      correctAnswer: optionEl.value.singleOption
    })
  }


  selectMultipleOptionAnswers(event, el, optionEl, optionIndex, questionIndex) {
    const control: any = <FormArray>this.questionsForm.controls.question;
    let correctAnswerData = this.questionsForm.controls.question.at(questionIndex).value.correctAnswer;
    if (event && event.checked) {
      if (correctAnswerData && correctAnswerData.length) {
        correctAnswerData.push({ value: optionEl.value.singleOption, index: optionIndex })
        control.controls[questionIndex].patchValue({
          correctAnswer: correctAnswerData
        })
      } else {
        control.controls[questionIndex].patchValue({
          correctAnswer: [{ value: optionEl.value.singleOption, index: optionIndex }]
        })
      }
    } else {
      let index = correctAnswerData.findIndex((x) => x.index === optionIndex)
      if (index !== -1) {
        correctAnswerData.splice(index, 1)
      }
      control.controls[questionIndex].patchValue({
        correctAnswer: correctAnswerData
      })
    }
  }

  correctAnswerInput(event, el, optionEl, i) {

    console.log("CONTROLS VALUE", el.controls.type)
    if (el.controls.type.value && el.controls.type.value !== 'Multiple Option') {
      el.controls.correctAnswer.updateValueAndValidity();
      console.log("Single comtrol ======>", el.controls.correctAnswer.value, i)
      let flag = 0;
      <FormArray>el.controls.options.controls.forEach((singleControl) => {
        console.log("Single comtrol ======>", singleControl.value.singleOption)
        if (singleControl.value.singleOption == el.controls.correctAnswer.value) {
          flag = 1;
        }
      });

      if (flag == 0) {
        (<HTMLInputElement>document.getElementById('correctAnswer' + i)).value = '';
        this.correctAnswer = '';
        let correctAnswetControl = el.controls.correctAnswer;
        correctAnswetControl.value = ''
        correctAnswetControl.updateValueAndValidity();
      }

      console.log(event, el, optionEl);
      console.log("correct Answer =====>", this.correctAnswer);
    } else {
      console.log("THIS IS FORM MULTIPLE ELEMENT")
    }
  }
  // SUBMIT FUMCTION IS NOT CALLED
  // submit(){
  //   // console.log("this is the final form array", this.questionsForm.value);
  //   console.log("this.detailsForm.value.criteria == ", this.detailsForm.value.criteria)
  //   let obj = {
  //     quizId: this.quizId,
  //     questions: this.questionsForm.value,
  //     quizSummary: this.detailsForm.value.summaryTitle,
  //     quizData: this.detailsForm.value.summaryData,
  //     quizCriteria: this.detailsForm.value.criteria,
  //   }
  //   console.log("%cTHE FINAL OBJECT TO SEND IS", "color:red", obj);

  //   this._quizService.addQuestion(obj).subscribe(res=>{
  //     console.log("QUESTIONS ADDED")
  //     this.openSnackBar("Quiz updated successfully", "OK")
  //   })
  // }
  uploadImage(i, el) {
    console.log('el clicked for images', el.value.questionId)
    this.openDialog(NewFileModalComponent, { isQuestionImg: 'Yes' }).subscribe(res => {
      console.log("res of files uploads", res[0].Location)
      const control = <FormArray>this.questionsForm.controls.question;
      console.log("%cCONTROLS", "color:red", control)
      let filesOfQuestions = this.questionsForm.get("question").controls[i] as FormArray
      res.forEach((singleImage) => {
        filesOfQuestions.value.files.push(singleImage);
      });
      this.openSnackBar("Images uploaded successfully", "OK")
      console.log(control.controls[i])
      // control.controls[i].patchValue({
      //   files: res
      // })
      console.log(control.controls[i].value)
      console.log(control.controls)
    })
  }
  viewImages(i) {
    console.log(i);
    // this.questionsForm.get('files')
    let filesOfQuestions = this.questionsForm.get("question").controls[i] as FormArray
    console.log(this.questionsForm.get("question") as FormArray)
    console.log(filesOfQuestions.value.files)
    // if(filesOfQuestions.value.files)
    this.openDialog(FileTileComponent, { disableClose: true, isAllImage: true, imagesArray: filesOfQuestions.value.files }).subscribe(res => {
      console.log("all deleted images ==========+>", filesOfQuestions);
      console.log("all deleted images ==========+>", this.questionsForm.get("question").controls[i].controls.files as FormArray);
      console.log("res of files uploads", res);
      this.deletedImages = res;
      let filesFormArray = this.questionsForm.get("question").controls[i].controls.files as FormArray;

      // <FormArray>filesOfQuestions.controls[0]
      res.forEach((string) => {
        filesFormArray.controls.forEach((singleControl, index) => {
          console.log("single file =====>", singleControl);
          if (typeof string == 'object') {
            if (string._id == singleControl.value._id) {
              filesFormArray.controls.splice(index, 1);
            }
          }
          // if((string == singleFile.Location) || (string == singleFile.path)){
          //   // console.log("Match", "color:red", string , singleFile.Location)
          //   filesOfQuestions.value.files.splice(index, 1);
          // }
        });

      });

      console.log(this.questionsForm)

    });

    console.log("happy");
  }




  addFileModal() {


    let obj = {
      isCreateQuiz: true
    }

    // if (this.materialId != undefined) {
    let addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        this.files.push(file);
      })

      console.log("file value after push", this.files);

      this.openSnackBar("File uploaded successfully!", "Ok");

    }, err => {
      return this.openSnackBar("Something went wrong!", "Ok");
    });
  }


  updateQuestions() {
    this.buttonLoaderDelete = true;
    let control = this.questionsForm.get("question").controls/*[i].controls.files as FormArray*/
    console.log(control)
    control.forEach((singleQuestion) => {
      // console.log(singleQuestion.controls.options.controls.forEach(()))
      if (singleQuestion.value.type == 'Text') {
        console.log("VALIDATION CHANGEING ===================");
        <FormArray>singleQuestion.controls.options.controls.forEach((singleControl) => {
          console.log("Single comtrol ======>", singleControl)
          singleControl.controls.singleOption.clearValidators()
          singleControl.controls.singleOption.updateValueAndValidity();
        });
      }
    });
    let obj = {
      quizId: this.quizId,
      questions: this.questionsForm.value,
      quizSummary: this.detailsForm.value.summaryTitle,
      quizData: this.detailsForm.value.summaryData,
      additionalInfo: this.detailsForm.value.additionalData,
      quizCriteria: this.detailsForm.value.criteria,
      deletedImages: this.deletedImages,
      files: this.files
    }

    console.log("%cTHE FINAL OBJECT TO SEND IS", "color:red", obj);
    console.log("update obj here=====>", obj)

    console.log("%cTHE questionsForm", "color:green", this.questionsForm);
    console.log("%cTHE questionsForm", "color:green", this.questionsForm.valid);

    // console.log("%cTHE detail forms", "color:green", this.detailsForm.valid);
    console.log("%cTHE detail forms", "color:green", this.detailsForm);
    console.log("%cTHE detail forms", "color:green", this.detailsForm.valid);

    console.log("THIS IS FOR EDIT", this.questionsForm.value);
    //if (this.questionsForm.valid && this.detailsForm.valid) {
    this.buttonLoaderDelete = true
    this._quizService.updateQuizById(obj).subscribe(res => {
      console.log("res", res);
      this.buttonLoaderDelete = false
      //this._location.back();

      // this.router.navigateByUrl('jobs/'+this.jobId)
      this.openSnackBar("Quiz updated successfully", "OK")
    }, err => {
      this.buttonLoaderDelete = false
      this.openSnackBar("Erro in Quiz update", "FAILED")
      console.log(err)
    });
    //}
    //else {
    //  this.buttonLoaderDelete = false
    //  this.markFormGroupTouched(this.detailsForm);
    //  this.markFormGroupTouched(this.questionsForm)
    //  this.openSnackBar("Please review your form and fill all questions tailing with * symbol.", "FAILED")
    //}
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    console.log(formGroup.controls);
    (<any>Object).values(formGroup.controls).forEach(control => {
      console.log(control)
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, disableClose: true });
    return dialogRef.afterClosed();
  }

  getQuestions() {
    this._quizService.getQuestionsByQuizId(this.quizId).subscribe(response => {
      console.log("what is response of quiz", response);

      let res = response.data.data
      console.log("res in create quiz", res);
      this.quizEdit = res
      if (res) {
        if (res.quizDetail) {
          this.quizName = res.quizDetail.quizName
          this.quizDescription = res.quizDetail.quizDescription
          this.isDate = res.quizDetail.isDate
          this.isUnits = res.quizDetail.isUnits
          this.checkAnswers = res.quizDetail.checkAnswers
          this.calcScore = res.quizDetail.calcScore
          this.minMarks = res.quizDetail.minMarks
          this.files = res.quizDetail.files
          this.isEvidence = res.quizDetail.isEvidence
          //this.inputList = res.quizDetail.inputList
          console.log("MIN MARKS HERE", this.minMarks)
          if (res.quizDetail.quizSummary) {
            this.isSummaryTitle = res.quizDetail.quizSummary.title
            this.isSummaryData = res.quizDetail.quizSummary.data
          }
          if (res.quizDetail.additionalInfo) {
            this.isAdditionalData = res.quizDetail.additionalInfo
          }
          this.createForm(this.quizEdit)
        }

        // console.log(this.isSummaryTitle, this.isSummaryData);
      }
      else {
        this.getQuiz()
      }
    })
  }


  getQuiz() {
    this._quizService.getQuizByQuizId(this.quizId).subscribe(res => {
      console.log("res in getQuizById", res)
      this.quizName = res.quizName
      this.quizDescription = res.quizDescription
      this.isDate = res.isDate

      this.isUnits = res.isUnits
      this.checkAnswers = res.checkAnswers
      this.calcScore = res.calcScore
      this.minMarks = res.minMarks
      //this.inputList = res.inputList
      console.log("MIN MARKS HERE", this.minMarks)
      this.createForm()
    })
  }



}
